export default "__VITE_ASSET__KgK5GWIw__";